@if (!userInfoSubmitted && userInfoFields && userInfoFields.length > 0) {
<form [formGroup]="userInfoForm" class="questionnaire-form"
  [style.background-color]="questionnaire?.mainContentTemplate?.backGround?.bgColor || 'transparent'"
  [style.overflow-y]="'auto'" [style.width]="'100%'" [style.display]="'flex'" [style.flex-direction]="'column'">
  <div class="questionnaire-form-content" [style.gap]="questionnaire?.mainContentTemplate?.questionSpacing + 'px'">
    <div class="questionnaire-form-content-section"
      [style.gap]="questionnaire?.mainContentTemplate?.questionSpacing + 'px'">
      @for (field of userInfoFields; track field.fieldName; let i = $index) {
      <div [class.question-error]="showUserInfoValidationErrors && userInfoValidationErrors[field.fieldName]">
        @switch (field.fieldType) {
        @case ('EMAIL') {
        <app-short-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [inputType]="'email'"
          [questionNumber]="i + 1" [formControl]="getUserInfoControl(field.fieldName)"
          [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
           />
        }
        @case ('NUMBER') {
        <app-short-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [inputType]="'number'"
          [questionNumber]="i + 1" [formControl]="getUserInfoControl(field.fieldName)"
          [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
           />
        }
        @case ('NUMBERS') {
        <app-short-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [inputType]="'number'"
          [questionNumber]="i + 1" [formControl]="getUserInfoControl(field.fieldName)"
          [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
           />
        }
        @case ('DATE') {
        <app-short-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [inputType]="'date'"
          [questionNumber]="i + 1" [formControl]="getUserInfoControl(field.fieldName)"
          [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
           />
        }
        @case ('URL') {
        <app-short-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [inputType]="'url'"
          [questionNumber]="i + 1" [formControl]="getUserInfoControl(field.fieldName)"
          [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
          />
        }
        @case ('PHONE') {
        <app-mobile [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [questionNumber]="i + 1"
          [formControl]="getUserInfoControl(field.fieldName)" [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)" />
        }
        @case ('TEXT') {
        <app-short-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [inputType]="'text'"
          [questionNumber]="i + 1" [formControl]="getUserInfoControl(field.fieldName)"
          [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
           />
        }
        @case ('LONG_TEXT') {
        <app-long-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [questionNumber]="i + 1"
          [formControl]="getUserInfoControl(field.fieldName)" [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
           />
        }
        @case ('FULL_NAME') {
        <app-short-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [inputType]="'text'"
          [questionNumber]="i + 1" [formControl]="getUserInfoControl(field.fieldName)"
          [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
           />
        }
        @default {
        <app-short-text [questionnaire]="questionnaire" [question]="getUserInfoQuestion(field)" [inputType]="'text'"
          [questionNumber]="i + 1" [formControl]="getUserInfoControl(field.fieldName)"
          [isInvalid]="isUserInfoFieldInvalid(field.fieldName)"
          [errorMessage]="getUserInfoFieldErrorMessage(field.fieldName)"
          (answerChange)="onUserInfoChange(field.fieldName, $event)"
          [placeholder]="'Enter ' + (field.fieldName | titlecase)"
          />
        }
        }
        @if (showUserInfoValidationErrors && userInfoValidationErrors[field.fieldName]) {
        <p class="error-message">
          {{ getUserInfoFieldErrorMessage(field.fieldName) | titlecase }}
        </p>
        }
      </div>
      }
    </div>
  </div>
  <div class="pagination-controls">
    @if (isUserInfoOptional()) {
    <button type="button" class="pagination-btn pagination-btn--prev skip-user-info-btn" (click)="skipUserInfo()">
      <i class="fa-solid bi bi-skip-end-fill"></i>
      Skip
    </button>
    }
    <button type="button" class="pagination-btn pagination-btn--next" (click)="onSubmitUserInfo()"
      [style.background-color]="questionnaire?.welcomeScreenTemplate?.button?.bgColor "
      [style.color]="questionnaire?.welcomeScreenTemplate?.button?.fontColor"
      [style.font-family]="questionnaire?.welcomeScreenTemplate?.button?.fontFamily"
      [style.font-weight]="questionnaire?.welcomeScreenTemplate?.button?.boldStyle">
      Next
      <i class="fa-solid fa-chevron-right text-xs"></i>
    </button>
  </div>
</form>
}

<!-- Questions Form -->
@if (userInfoSubmitted && publicQuestions && publicQuestions.length > 0) {
<form [formGroup]="previewForm" class="questionnaire-form"
  [style.background-color]="questionnaire?.mainContentTemplate?.backGround?.bgColor || 'transparent'"
  [style.overflow-y]="'auto'" [style.width]="'100%'" [style.display]="'flex'" [style.flex-direction]="'column'">
  <div class="questionnaire-form-content" [style.gap]="questionnaire?.mainContentTemplate?.questionSpacing + 'px'">
    <div class="questionnaire-form-content-section"
      [style.gap]="questionnaire?.mainContentTemplate?.questionSpacing + 'px'">
      @for (question of currentPageQuestions; track question.questionId; let i = $index) {
      <div [attr.data-question-id]="question.questionId"
        [class.question-error]="showValidationErrors && formErrors[question.questionId]">
        @switch (question.questionType) {
        @case (quectionTypes.CHOICE_BASED) {
        @switch (question.questionSubType) {
        @case (questionSubTypes.LIST) {
        @if (question.questionSpecificOptions.allowMultipleResponses) {
        <app-check-box [question]="question" [questionnaire]="questionnaire"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        } @else {
        <app-radio-button [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        }
        @case (questionSubTypes.BUTTON_CHOICE) {
        <app-button-select-options [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (questionSubTypes.DROPDOWN) {
        @if (question.questionSpecificOptions.allowMultipleResponses) {
        <app-multi-select [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        } @else {
        <app-single-select [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        }
        }
        }
        @case (quectionTypes.TEXT_INPUT) {
        @switch (question.questionSubType) {
        @case (questionSubTypes.SHORT_TEXT) {
        <app-short-text [questionnaire]="questionnaire" [question]="question" [inputType]="'text'"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)"
           />
        }
        @case (questionSubTypes.LONG_TEXT) {
        <app-long-text [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)"
           />
        }
        @case (questionSubTypes.FULL_NAME) {
        <app-short-text [questionnaire]="questionnaire" [question]="question" [inputType]="'text'"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)"
           />
        }
        @case (questionSubTypes.EMAIL) {
        <app-short-text [questionnaire]="questionnaire" [question]="question" [inputType]="'email'"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (questionSubTypes.NUMBERS) {
        <app-short-text [questionnaire]="questionnaire" [question]="question" [inputType]="'number'"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (questionSubTypes.WEBSITE_URL) {
        <app-short-text [questionnaire]="questionnaire" [question]="question" [inputType]="'url'"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (questionSubTypes.CALENDAR) {
        <app-short-text [questionnaire]="questionnaire" [question]="question" [inputType]="'date'"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (questionSubTypes.PHONE_NUMBER) {
        <app-mobile [questionnaire]="questionnaire" [question]="question" [questionNumber]="getGlobalQuestionNumber(i)"
          [formControl]="getQuestionControl(question.questionId)" [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        }
        }
        @case (quectionTypes.SLIDERS) {
        <app-slider [questionnaire]="questionnaire" [question]="question" [questionNumber]="getGlobalQuestionNumber(i)"
          [formControl]="getQuestionControl(question.questionId)" [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (quectionTypes.RATING_SCALE) {
        @switch (question.questionSubType) {
        @case (questionSubTypes.OPINION_SCALE) {
        <app-opinion-scale [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (questionSubTypes.RATING_SCALE) {
        <app-rating-scale [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        }
        }
        @case (quectionTypes.NPS) {
        <app-nps [questionnaire]="questionnaire" [question]="question" [questionNumber]="getGlobalQuestionNumber(i)"
          [formControl]="getQuestionControl(question.questionId)" [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (quectionTypes.RANK_ORDER) {
        <app-ranking-order [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        @case (quectionTypes.SOCIAL_REVIEW) {
        <app-social-review [questionnaire]="questionnaire" [question]="question"
          [questionNumber]="getGlobalQuestionNumber(i)" [formControl]="getQuestionControl(question.questionId)"
          [isInvalid]="isQuestionInvalid(question.questionId)"
          [errorMessage]="getQuestionErrorMessage(question.questionId)" (answerChange)="onAnswerChange($event)" />
        }
        }
        @if (showValidationErrors && formErrors[question.questionId]) {
        <p class="error-message">
          {{ getQuestionErrorMessage(question.questionId) | titlecase }}
        </p>
        }
      </div>
      }
    </div>
    <div class="pagination-controls">
      @if (!isFirstPage()) {
      <button type="button" class="pagination-btn pagination-btn--prev" (click)="onPreviousPage()"
        [style.background-color]="questionnaire?.welcomeScreenTemplate?.button?.bgColor "
        [style.color]="questionnaire?.welcomeScreenTemplate?.button?.fontColor"
        [style.font-family]="questionnaire?.welcomeScreenTemplate?.button?.fontFamily"
        [style.font-weight]="questionnaire?.welcomeScreenTemplate?.button?.boldStyle">
        <i class="fa-solid fa-chevron-left text-xs"></i>
        Previous
      </button>
      }
      @if (!isLastPage()) {
      <button type="button" class="pagination-btn pagination-btn--next" (click)="onNextPage()"
        [style.background-color]="questionnaire?.welcomeScreenTemplate?.button?.bgColor "
        [style.color]="questionnaire?.welcomeScreenTemplate?.button?.fontColor"
        [style.font-family]="questionnaire?.welcomeScreenTemplate?.button?.fontFamily"
        [style.font-weight]="questionnaire?.welcomeScreenTemplate?.button?.boldStyle">
        Next
        <i class="fa-solid fa-chevron-right text-xs"></i>
      </button>
      }
      @if (isLastPage()) {
      <button type="button" class="pagination-btn pagination-btn--next" (click)="onSubmit()"
        [style.background-color]="questionnaire?.welcomeScreenTemplate?.button?.bgColor "
        [style.color]="questionnaire?.welcomeScreenTemplate?.button?.fontColor"
        [style.font-family]="questionnaire?.welcomeScreenTemplate?.button?.fontFamily"
        [style.font-weight]="questionnaire?.welcomeScreenTemplate?.button?.boldStyle">
        <i class="fa-solid fa-send text-xs"></i>
        @if (isSubmitting) {
        <app-spinner [size]="'small'" [variant]="'primary'" />
        }
        @else {
        Submit
        }
      </button>
      }
    </div>
  </div>
</form>
}